import React, { useEffect } from "react";
import { ProgressBar } from "primereact/progressbar";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const ProgressBarCustom = (props) => {
  const userConnected = props.auth.userConnected;
  useEffect(() => {}, [userConnected]);

  return (
    <p>
      <p>Profil rempli à {userConnected.profileCompletionRate / 100}%</p>
      <ProgressBar
        value={userConnected.profileCompletionRate / 100}
        showValue={false}
        className="profilDescription__progressBar"
      ></ProgressBar>
    </p>
  );
};

ProgressBarCustom.propTypes = {
  auth: PropTypes.object,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(ProgressBarCustom);
